import styled from 'styled-components';
import Input from '../input/Input';
export const CustomInput = styled(Input) ``;
//# sourceMappingURL=styles.js.map